import { cva } from 'class-variance-authority';
export const inputStyles = cva([
    'box-border',
    'placeholder:font-component',
    'font-component',
    'bg-text-field',
    'border-text-field',
    'hover:bg-text-field-hover',
    'hover:border-text-field-hover',
    'focus:bg-text-field-focus',
    'focus:outline-none',
    'focus:ring-text-field-focus',
    'focus:!ring-1',
    'transition-colors duration-75 ease-out',
    'autofill:!bg-text-field autofill:shadow-none',
    'resize-none',
    'flex flex-col justify-center items-center',
    'cursor-pointer',
], {
    variants: {
        state: {
            default: 'focus:ring-text-field-focus focus:border-info-focus text-text-field-content border',
            error: 'focus:ring-text-field-focus-error focus:border-error-focus text-text-field-content',
            success: 'focus:ring-text-field-focus-success focus:border-success-focus text-text-field-content',
            disabled: 'pointer-events-none cursor-not-allowed border-text-field-disabled bg-text-field-disabled text-text-field-disabled',
        },
        size: {
            sm: 'p-50 rounded-component-xs gap-component-sm w-800 h-800',
            md: 'p-50 rounded-component-sm gap-component-md w-1000 h-1000',
            lg: 'p-100 rounded-component-lg gap-component-lg w-1200 h-1200',
            xl: 'p-150 rounded-component-md gap-component-xl w-1800 h-1800',
        },
    },
    defaultVariants: {
        state: 'default',
        size: 'md',
    },
});
export const imageStyles = cva('h-full w-full object-cover', {
    variants: {
        size: {
            sm: 'rounded-[4px]',
            md: 'rounded-component-xs',
            lg: 'rounded-component-xs',
            xl: 'rounded-component-sm',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
export const hintStyles = cva('font-light', {
    variants: {
        state: {
            default: 'text-text-field-hint',
            error: 'text-text-field-hint-error',
            success: 'text-text-field-hint',
            disabled: 'text-text-field-disabled',
        },
        size: {
            sm: 'input-hint-sm',
            md: 'input-hint-md',
            lg: 'input-hint-lg',
            xl: 'input-hint-xl',
        },
    },
    defaultVariants: {
        state: 'default',
        size: 'md',
    },
});
